import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Box, CircularProgress } from '@mui/material';

const AuthRoute = ({ children }) => {
  const { currentUser, loading } = useAuth();

  if (loading) {
    return (
      <Box 
        sx={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          height: '100vh' 
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  // If user is already logged in, redirect to dashboard
  if (currentUser) {
    // Check if email is verified
    if (!currentUser.emailVerified) {
      return <Navigate to="/auth/verify-email" replace />;
    }
    return <Navigate to="/admin/dashboard" replace />;
  }

  // If user is not logged in, allow access to auth pages
  return children;
};

export default AuthRoute;